/* eslint-disable no-implied-eval */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clearSuccessMessage } from "../../../state/ducks/workflow/index";
import { clearSuccessMessageLoyalty } from "../../../state/ducks/loyalty/index";

class Info extends Component {
  componentDidMount() {
    var that = this;
    setTimeout(function () {
      if (that.props.header === "Referansınız alınmıştır.") {
        that.props.clearSuccessMessageLoyalty();
        that.props.history.push("/Home/MyReferences");
      } else {
        that.props.clearSuccessMessage();
        that.props.history.push("/Home/MyDemands");
      }
    }, 3000);
  }
  render() {
    const { header, body } = this.props;
    return (
      <div className="container-fluid">
      {/* yesil Alan*/}
      <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
              {/* KUTU 1 */}
              <div className="row no-gutters t-kutu t-yesilCizgi">
                  <div
                      className="col bosluk backtop"
                      style={{
                          backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                      }}
                  >
                      {/* içerikler */}
                      <div className="row no-gutters pb-4">
                          <div className="col-12 d-flex justify-content-center pb-2">
                              <i className="t-icon-bubble1 t-icGenelBaslikIconYesil" />
                          </div>
                          <div className="col-12 d-flex justify-content-center pb-3 t-icGenelBaslikYesil">
                              {header}
                          </div>
                          <div className="col-12 text-center t-icYazilar20pt">
                             {body}
                          </div>
                      </div>
                      {/* içerikler BİTTİ */}
                  </div>
                  <div className="col-auto renk" />
              </div>
              {/* KUTU 1 BİTTİ */}
          </div>
      </div>
      {/* Duyurlar Baslık*/}
      {/* duyrular Bitti*/}
      <div className="row" style={{ height: 30 }} />
  </div>

    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => ({
  clearSuccessMessage: () => dispatch(clearSuccessMessage()),
  clearSuccessMessageLoyalty: () => dispatch(clearSuccessMessageLoyalty())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Info));
